// 首页
import type { RouteRecordRaw } from 'vue-router'
import { defaultLayout } from '@/router/base'

const routes: RouteRecordRaw[] = [
  {
    path: '/home',
    name: 'Home',
    component: defaultLayout,
    meta: {
      locale: 'common.menus.home',
      requiresAuth: true,
      icon: 'home',
      hideChildrenInMenu: true,
      activeMenu: 'Home',
      order: 0,
    },
    children: [
      {
        path: '',
        name: 'HomeIndex',
        component: () => import('@/views/home/index.vue'),
        meta: {
          locale: 'common.menus.home',
          requiresAuth: true,
          roles: ['*'],
          activeMenu: 'Home',
          isTopMenu: true,
        },
      },
    ],
  },
]

export default routes
